import { Component, Input, Output, EventEmitter } from '@angular/core';

export type NotifFilter = 'all' | 'read' | 'unread' | 'mentioned';

interface FilterOption {
  value: NotifFilter;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-notifications-filter-dropdown',
  standalone: true,
  templateUrl: './notifications-filter-dropdown.component.html',
  styleUrls: ['./notifications-filter-dropdown.component.scss'],
})
export class NotificationsFilterDropdownComponent {
  @Input() activeFilter: NotifFilter = 'all';
  @Output() filterChange = new EventEmitter<NotifFilter>();

  readonly options: FilterOption[] = [
    { value: 'read', label: 'Read', icon: 'bi-check' },
    { value: 'unread', label: 'Unread', icon: 'bi-eye' },
    { value: 'mentioned', label: 'Mentioned Me', icon: 'bi-chat-quote' },
    { value: 'all', label: 'All Workspace Updates', icon: 'bi-clock' },
  ];

  select(value: NotifFilter): void {
    this.filterChange.emit(value);
  }
}
